import { useCurrentUser } from 'src/services/user/userService'
import UserMenu from './UserMenu';
import classes from './TopMenu.module.scss';
import { useAtom } from 'jotai';
import WaitRipple from '../WaitRipple';
import CoursePartMenu from './CoursePartMenu';
import LnIcon from '../LnIcon';
import CourseMenu from './CourseMenu';
import { waitRippleAtom } from 'src/services/WaitRippleService';
import { textReadyAtom } from 'src/utils/languageService';
import LanguageMenu from '../LanguageMenu/LanguageMenu';
import { useI18n } from 'src/utils/lni18n';
import { loginService } from 'src/login/LoginService';
import ManualsMenu from '../LanguageMenu/ManualsMenu';
import ThemeMenu from '../ThemeMenu/ThemeMenu';



export default function TopMenu(props: { setOpenSideBar: (state: boolean) => void }) {
    const { currentUser } = useCurrentUser();
    const { languageService: t } = useI18n();

    const [waitRipple] = useAtom(waitRippleAtom);
    const [textReady] = useAtom(textReadyAtom);




    return (
        <>
            <div className={`ms-5 p-2 flex gap-2 text-lg d-flex align-items-center ${classes.topmenu}`}>
                {waitRipple && <WaitRipple />}

                <div className='toggle'>
                    <button className='btn btn-link p-3' onClick={() => props.setOpenSideBar(true)}>
                        <LnIcon name="next-2" className='icon-small' />
                    </button>
                </div>

                {textReady && currentUser === null && <>
                    <button type='button' data-testid="btn-login" onClick={() => loginService.setOpenDialog(true)} className='ms-auto mt-2 me-2 btn btn-small btn-warning'>{t.getText("login")}</button>
                    <div className="me-4 mt-2">
                        <ThemeMenu />
                    </div>
                </>}

                {textReady && currentUser && <>
                    <div className="d-flex flex-wrap" >
                        <div className='me-3'>
                            <CoursePartMenu />
                        </div>
                        <CourseMenu />
                    </div>



                    <div className="ms-auto d-flex pe-4" >

                        <div className="me-5 mt-2">
                            <ManualsMenu caretClass={"white-caret"} />
                        </div>

                        <div className="me-5 mt-2">
                            <LanguageMenu caretClass={"white-caret"} />
                        </div>

                        <div className="me-3 mt-2">
                            <ThemeMenu />
                        </div>
                        <UserMenu />


                    </div>
                </>}

            </div>


        </>
    )
}
